import { render, staticRenderFns } from "./SelectVenuesModalMessages.vue?vue&type=template&id=8e0c4dac&"
import script from "./SelectVenuesModalMessages.vue?vue&type=script&lang=ts&"
export * from "./SelectVenuesModalMessages.vue?vue&type=script&lang=ts&"
import style0 from "./SelectVenuesModalMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports